module.exports = __webpack_public_path__ + "static/media/loginpage_icon.442f3955.png";